import TeachDashboardIcon from 'assets_2/icons/teacher-dashboard-icon.svg';
import CourseBookWhiteIcon from '../Assets/images/icons/course-book-white.svg';
import CourseBookIcon from '../Assets/images/icons/course-book.svg';
import WorkshopCapIcon from '../Assets/images/icons/graudation-cap.svg';
import GroupIcon from '../assets_2/icons/group-badge.svg';
import PlayIcon from '../assets_2/icons/player/play-icon.svg';
import volumeMuteIcon from '../assets_2/icons/player/volume-mute.svg';
import PlaylistIcon from '../assets_2/icons/Playlist-icon.svg';
import SignOutIcon from '../assets_2/icons/sign-out-icon.svg';
import StarIcon from '../assets_2/icons/star.svg';
import PlusIcon from '../assets_2/images/membersplus/plus.svg';

const Images = {
  WorkshopCapIcon,
  volumeMuteIcon,
  PlayIcon,
  StarIcon,
  CourseBookIcon,
  PlaylistIcon,
  GroupIcon,
  SignOutIcon,
  PlusIcon,
  TeachDashboardIcon,
  CourseBookWhiteIcon
};

export default Images;
